<template>
  <div
    :class="{...configStyleClasses, ...widgetClasses}"
    :style="configStyles"
    :lang="value.config.lang"
    v-html="value.value"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    widgetClasses: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    configStyles() {
      const textDecoration = `${
        this.value.config.underline ? 'underline' : ''
      } ${this.value.config.strikethrough ? 'line-through' : ''}`
      return {
        ...(textDecoration.trim() ? { 'text-decoration': textDecoration } : {}),
      }
    },
    configStyleClasses() {
      return {
        italic: this.value.config.italic,
        'font-bold': this.value.config.bold,
        'text-left': this.value.config.alignment === 'left',
        'text-center': this.value.config.alignment === 'center',
        'text-right': this.value.config.alignment === 'right',
        'text-sm': this.value.config.size === 'small',
        'text-base': this.value.config.size === 'medium',
        'text-lg': this.value.config.size === 'large',
      }
    },
  },
}
</script>
